"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment[Environment["Dev"] = 0] = "Dev";
    Environment[Environment["QA"] = 1] = "QA";
    Environment[Environment["Production"] = 2] = "Production";
})(Environment || (exports.Environment = Environment = {}));
//# sourceMappingURL=Environment.js.map